// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2bb4x","consentsList":"PatientConsents_consentsList__2fOwA","consentsListEmpty":"PatientConsents_consentsListEmpty__34uEW"};